import * as React from 'react'
import {FC} from 'react'
import {useGetDataForRenderQuery} from '../../store/api/express-api'
import {useGetRegionsQuery} from '../../store/api/fias-api'
import Loading from '../../../../../forms/activation/property-mts/components/loading'
import Calculator from '../calculator'
import WarningFilled from '@ant-design/icons/lib/icons/WarningFilled'

interface AppPropsInterface {
    initValues: object
}

const App: FC<AppPropsInterface> = ({initValues}) => {
    const getDataQuery = useGetDataForRenderQuery()
    const regionsQuery = useGetRegionsQuery()

    return (
        <>
            {(getDataQuery.isLoading || regionsQuery.isLoading) && <Loading />}

            {(getDataQuery.isSuccess || regionsQuery.isSuccess) && (
                <Calculator initValues={initValues} />
            )}

            {(getDataQuery.isError || regionsQuery.isError) && (
                <>
                    <WarningFilled style={{color: '#f5222d'}} /> При загрузке данных произошла
                    ошибка. Попробуйте позже или обратитесь в службу поддержки.
                </>
            )}
        </>
    )
}

export default App
